<template>
    <v-form v-model="form" ref="form_step_2">
        <v-card class="mt-5 mb-5">
            <v-card-title class="grey lighten-4 p-2">
                <h4 class="m-0">Confirm Reservation</h4>
            </v-card-title>

            <template v-if="$store.state.model.reservation.group_link_id">
                <v-row>
                    <v-col>
                        <ticket-information></ticket-information>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <rental-information></rental-information>
                    </v-col>
                </v-row>
            </template>
            <template v-else>
                <v-card-title class="grey lighten-4 p-2" v-if="discounted_dates.length!==0 && !$store.state.model.reservation.is_delivery && (this.config.module_type_enabled != 0 && this.config.module_type == 'module_1')">
                    <h6 class="m-0 red--text">
                        NOTE: We have disabled discount on some dates: <template v-for="(date, index) in discounted_dates">{{date['start']}} to {{date['end']}}
                vscode-file://vscode-app/private/var/folders/8t/q34rd6393c368rx6t1l5wzw80000gn/T/AppTranslocation/C48FCADD-5376-40FA-A582-33C06D8946E4/d/Visual%20Studio%20Code%202.app/Contents/Resources/app/out/vs/code/electron-sandbox/workbench/workbench.html      <span v-if="discounted_dates.length > 0 && (index + 1) < discounted_dates.length">, </span></template>
                    </h6>
                </v-card-title>
                <v-row>
                    <v-col>
                        <ticket-information></ticket-information>
                    </v-col>
                    <v-col>
                        <rental-information></rental-information>
                    </v-col>
                </v-row>
            </template>
            <additional-information v-if="notes_in_advance"></additional-information>
        </v-card>
        <renters-list-table class="mt-2" title="Renters list" :no-action="true"></renters-list-table>
        <template v-if="!$store.state.model.reservation.group_link_id">
        <template v-if="gateway =='stripe'">
            <template v-if="!cost.free_checkout && skip_checkout==0">
                <v-col cols="12">
                    <v-card class="mt-5" v-if="is_prepay ? (prepay_payment || only_save_card_at_prepay) : only_save_card_at_advanced || advance_reservation_payment_checkout">
                        <v-card-title class="grey lighten-4 p-2">
                            <h5 class="m-0 font-weight-bold text-break" v-if="(!is_prepay && only_save_card_at_advanced) || (is_prepay && only_save_card_at_prepay)">
                                Please enter your credit card to save this reservation, you will not be charged at this time
                            </h5>
                            <h4 class="m-0" v-else>
                                Reservation Total: <span class="blue--text text--accent-4">${{ amount }}</span>
                                <span class="error--text  text-break text--accent-4" v-if="charge_50_percent || charge_25_percent || charge_10_percent || charge_10_per_person || charge_20_per_person || charge_30_per_person">
                                    ( {{ deposite_text }} )
                                </span>
                            </h4>
                        </v-card-title>
                        <div class="p-2">
                            <h4 class="m-0" v-if="(!is_prepay && only_save_card_at_advanced) || (is_prepay && only_save_card_at_prepay)">
                                <span class=" error--text"> Reservation Total:</span> <span class="blue--text text--accent-4">${{ amount }}</span>
                                <span class="error--text  text-break text--accent-4" v-if="charge_50_percent || charge_25_percent || charge_10_percent || charge_10_per_person || charge_20_per_person || charge_30_per_person">
                                    ( {{ deposite_text }} )
                                </span>
                            </h4>
                            <span class="mt-5 error--text  text-break" v-if="(advance_reservation_payment_checkout && (!charge_50_percent && !charge_25_percent && !charge_10_percent && !charge_10_per_person && !charge_20_per_person && !charge_30_per_person) && !only_save_card_at_advanced) || (is_prepay && prepay_payment && !only_save_card_at_prepay)">
                                        Please enter your credit card information to complete the reservation
                                    </span>
                            <div id="card-element"></div>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <with-validation field="agreement" v-slot="{bind,on}">
                        <v-checkbox v-bind="bind"
                                    v-on="on" v-if="is_prepay ? (prepay_payment || only_save_card_at_prepay) : only_save_card_at_advanced || advance_reservation_payment_checkout">
                            <template v-slot:label>
                                I have read and agree to the
                                <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_terms'})">{{ terms_and_conditions_title }}</a>,
                                <span v-if="show_sms_consent">
                                    <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_sms_consent'})">{{ sms_constent_title }}</a>,
                                </span>
                                <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_privacy_policy'})">{{ privacy_policy_title }}</a>
                                and
                                <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_cancelation_policy'})">{{ cancellation_policy_title }}</a>
                            </template>
                        </v-checkbox>
                    </with-validation>
                </v-col>
            </template>
            <template v-if="!cost.free_checkout && skip_checkout==0 && (((only_save_card_at_advanced==1 || advance_reservation_payment_checkout==1) && !is_prepay) || ((prepay_payment=='1' || only_save_card_at_prepay=='1') && is_prepay))">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <h6>This site is protected by Google reCAPTCHA</h6>
                    </div>
                </template>
            </template>
            <div class="mt-5">
                <div ref="recaptcha"> </div>
            </div>
            <div class="mt-5" >
                <errors-alert :errors="v__getErrors()"></errors-alert>
                <errors-alert v-if="typeof errorMessagesList !== 'undefined' && (typeof errorMessagesList === 'object' && errorMessagesList.length!==0 && v__getErrors().length===0)" :errors="errorMessagesList"></errors-alert>

                <v-btn
                    color="secondary"
                    :disabled="$store.state.config.stepLoading"
                    @click="go_back()"
                >
                    {{ 'Back'}}
                </v-btn>

                <v-btn
                    id="stripe-card-button"
                    color="primary"
                    :loading="$store.state.config.stepLoading"
                    :disabled="disabled_status"
                >
                    {{ is_prepay ? prepay_payment ? 'Pay' : 'Save' : !only_save_card_at_advanced && advance_reservation_payment_checkout && !cost.free_checkout && skip_checkout==0?'Pay':'Save' }}
                </v-btn>
            </div>
        </template>
        <template v-else-if="! is_using_square">
            <template v-if="!cost.free_checkout && do_not_show_price_on_checkout==0 && skip_checkout==0 && !($store.state.model.reservation._type=='advance' && !$store.state.model.reservation.is_seasonal && no_priceing_checkouts==1)">
                <payment-widget :amount="((prepay_payment || only_save_card_at_prepay) && is_prepay) ? parseFloat(prepay_total_price).toFixed(2) : cost.amount_to_be_paid"
                                :prepay="is_prepay"
                                reservation-type="advance"
                                :validation-id="v__validationId"
                                v-if="((prepay_payment || only_save_card_at_prepay) && is_prepay) || ((only_save_card_at_advanced || advance_reservation_payment_checkout) && !is_prepay)"></payment-widget>
            </template>
            <template v-if="!cost.free_checkout && skip_checkout==0 && (((only_save_card_at_advanced==1 || advance_reservation_payment_checkout==1) && !is_prepay) || ((prepay_payment=='1' || only_save_card_at_prepay=='1') && is_prepay))">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <h6>This site is protected by Google reCAPTCHA</h6>
                    </div>
                </template>
            </template>
            <div class="mt-5">
                <div ref="recaptcha"> </div>
            </div>
            <steps-navigation :error-messages-list="errorMessagesList"
                              :errors="v__getErrors()"
                              :next-button="is_prepay ? prepay_payment ? 'Pay' : 'Save' : ((!only_save_card_at_advanced && advance_reservation_payment_checkout) && !cost.free_checkout) &&  do_not_show_price_on_checkout==0 && skip_checkout==0 && !($store.state.model.reservation._type=='advance' && !$store.state.model.reservation.is_seasonal && no_priceing_checkouts==1) ?'Pay':'Save'"
                              @step-back="stepBack({validate:false,submit:false})"
                              @step-next="stepNext({stay:true})"></steps-navigation>
        </template>
        <template v-else-if="is_using_square">
            <template v-if="!cost.free_checkout && skip_checkout==0">
                <v-col cols="12" v-if="((prepay_payment || only_save_card_at_prepay) && is_prepay) || ((only_save_card_at_advanced || advance_reservation_payment_checkout) && !is_prepay)">
                    <v-card class="mt-5">
                        <v-card-title class="grey lighten-4 p-2">
                            <h5 class="m-0 font-weight-bold text-break" v-if="(!is_prepay && only_save_card_at_advanced) || (is_prepay && only_save_card_at_prepay)">
                                Please enter your credit card to save this reservation, you will not be charged at this time
                            </h5>
                            <h4 class="m-0" v-else>
                                Reservation Total: <span class="blue--text text--accent-4">${{ amount }}</span>
                                <span class="error--text  text-break text--accent-4" v-if="charge_50_percent || charge_25_percent || charge_10_percent || charge_10_per_person || charge_20_per_person || charge_30_per_person">
                                    ( {{ deposite_text }} )
                                </span>
                            </h4>
                        </v-card-title>
                        <div class="p-2">
                            <h4 class="m-0" v-if="(!is_prepay && only_save_card_at_advanced) || (is_prepay && only_save_card_at_prepay)">
                                <span class=" error--text"> Reservation Total:</span> <span class="blue--text text--accent-4">${{ amount }}</span>
                                <span class="error--text  text-break text--accent-4" v-if="charge_50_percent || charge_25_percent || charge_10_percent || charge_10_per_person || charge_20_per_person || charge_30_per_person">
                                    ( {{ deposite_text }} )
                                </span>
                            </h4>
                            <span class="mt-5 error--text  text-break" v-if="advance_reservation_payment_checkout && (!charge_50_percent && !charge_25_percent && !charge_10_percent && !charge_10_per_person && !charge_20_per_person && !charge_30_per_person) && !only_save_card_at_advanced">
                             Please enter your credit card information to complete the reservation
                        </span>
                            <div id="card-container"></div>
                        </div>
                    </v-card>
                </v-col>
            </template>
            <v-col cols="12">
                <with-validation field="agreement" v-slot="{bind,on}">
                    <v-checkbox v-bind="bind"
                                v-on="on" v-if="is_prepay ? (prepay_payment || only_save_card_at_prepay) : only_save_card_at_advanced || advance_reservation_payment_checkout">
                        <template v-slot:label>
                            I have read and agree to the
                            &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_terms'})">{{ terms_and_conditions_title }}</a>
                            <span v-if="show_sms_consent">
                                ,
                                &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_sms_consent'})">{{ sms_constent_title }}</a>
                            </span>
                            ,
                            &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_privacy_policy'})">{{ privacy_policy_title }}</a>&nbsp;
                            and
                            &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_cancelation_policy'})">{{ cancellation_policy_title }}</a>
                        </template>
                    </v-checkbox>
                </with-validation>
            </v-col>
            <template v-if="!cost.free_checkout && skip_checkout==0 && (((only_save_card_at_advanced==1 || advance_reservation_payment_checkout==1) && !is_prepay) || ((prepay_payment=='1' || only_save_card_at_prepay=='1') && is_prepay))">
                <template v-if='$store.state.resources.config.google_recaptcha=="1" && $store.state.resources.config.google_recaptcha_site_key!=""'>
                    <div class="mt-5">
                        <h6>This site is protected by Google reCAPTCHA</h6>
                    </div>
                </template>
            </template>
            <div class="mt-5">
                <div ref="recaptcha"> </div>
            </div>
            <div class="mt-5" >
                <errors-alert :errors="v__getErrors()"></errors-alert>
                <errors-alert v-if="typeof errorMessagesList !== 'undefined' && (typeof errorMessagesList === 'object' && errorMessagesList.length!==0 && v__getErrors().length===0)" :errors="errorMessagesList"></errors-alert>

                <v-btn
                    color="secondary"
                    :disabled="$store.state.config.stepLoading"
                    @click="go_back()"
                >
                    {{ 'Back'}}
                </v-btn>

                    <v-btn
                        id="card-button"
                        color="primary"
                        :loading="$store.state.config.stepLoading"
                        :disabled="disabled_status"
                    >
                        {{ is_prepay ? prepay_payment ? 'Pay' : 'Save' : !only_save_card_at_advanced && advance_reservation_payment_checkout && !cost.free_checkout && skip_checkout==0?'Pay':'Save' }}
                    </v-btn>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="mt-5" >
                <steps-navigation :error-messages-list="errorMessagesList"
                                  :errors="v__getErrors()"
                                  next-button="Save"
                                  @step-back="stepBack({validate:false,submit:false})"
                                  @step-next="stepNext({stay:true})"></steps-navigation>
            </div>
        </template>

        <v-dialog v-model="messageDialog.show" persistent max-width="500px">
            <message-modal :message="messageDialog.message" :success="messageDialog.success" :showPrintButton="false"></message-modal>
        </v-dialog>
    </v-form>
</template>

<script>
import MessageModal          from "../../../components/modals/MessageModal";
import UiManagerMixin        from "../../../mixins/UiManagerMixin";
import RentersListTable      from "../../../components/partials/RentersListTable";
import StepsNavigation       from "../../../components/partials/StepsNavigation";
import ValidatableComponent  from "../../../mixins/ValidatableComponent";
import cc_form__rules        from "../../../validation/scenarios/cc_form__rules";
import TicketInformation     from "./step3/TicketInformation";
import RentalInformation     from "./step3/RentalInformation";
import AdditionalInformation from "./step3/AdditionalInformation";
import PaymentWidget         from "./step3/PaymentWidget";
import {mapActions, mapGetters}          from "vuex";
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";
import WithValidation           from "../../../components/inputs/WithValidation";
import ErrorsAlert from "../../../components/partials/ErrorsAlert";
import moment from "moment";

export default {
    name      : "Step3",
    components: {
        MessageModal,
        PaymentWidget,
        WithValidation,
        ErrorsAlert,
        AdditionalInformation, RentalInformation, TicketInformation, RentersListTable, StepsNavigation
    },
    mixins    : [StepperComponentMixin, ValidatableComponent, UiManagerMixin],
    data      : () => ({
        form         : false,
        messageDialog: {
            show   : false,
            message: '',
            success: true
        },
        errorMessagesList: [],
        is_prepay     : false,
        stripe: null,
        recaptchaWidgetId : null,
        deposite_text: "",
    }),
    methods   : {
        ...mapActions(['do_checkout', 'do_store_prepay_reservation_checkout', 'do_store_prepay_reservation']),
        invisibleRecaptcha() {
            this.$store.commit('set_disabled_status', true);
            this.recaptchaWidgetId  = grecaptcha.render(this.$refs.recaptcha, {
                'sitekey'  : this.$store.state.resources.config.google_recaptcha_site_key,
                'callback' : this.rcapchaCallback.bind(this)
            });

            // if (this.hasRecaptchaRendered === false) {
            //     grecaptcha.execute();

            //     this.hasRecaptchaRendered = true;
            // }
        },
        rcapchaCallback(response) {
            this.$store.commit('set_model_value', {
                path : 'model.payment.g_recaptcha_response',
                value: response
            });
            this.$store.commit('set_rechapcha_is_checked', true);
            this.$store.commit('set_disabled_status', false);
        },
        invisibleRecaptchaStripe() {

            this.recaptchaWidgetId  = grecaptcha.render(this.$refs.recaptcha, {
                'sitekey'  : this.$store.state.resources.config.google_recaptcha_site_key,
                'callback' : this.rcapchaCallback
            });

            if (this.hasRecaptchaRendered === false) {
                grecaptcha.execute();

                this.hasRecaptchaRendered = true;
            }
        },
        // rcapchaCallback(){
        //     this.rechapchaIsChecked = true;
        //     this.$store.commit('set_disabled_status', false);
        // },
        async stepSubmit() {
            if(this.is_prepay){
                let result = '';
                if(this.prepay_payment || this.only_save_card_at_prepay) {
                    result = await this.do_store_prepay_reservation_checkout();                    
                } else {
                    result = await this.do_store_prepay_reservation();
                }

                if(result.data.success || result.success){
                    this.errorMessagesList = [];
                    this.showMessage('Prepaid Successfully');
                    return true;
                }
                if(result.data.hasOwnProperty('errors')){
                    this.errorMessagesList = [];
                    if(this.recaptchaWidgetId!= null){
                        grecaptcha.reset(this.recaptchaWidgetId);
                    }
                    Object.values(result.data.errors).forEach(val => {
                        this.errorMessagesList.push(val[0]);
                    });
                }else if(result.data.message!=="") {
                    if(this.recaptchaWidgetId!= null){
                        grecaptcha.reset(this.recaptchaWidgetId);
                    }
                    this.errorMessagesList = [result.data.message.includes(":")?result.data.message.split(":")[1]:result.data.message];
                }else{
                    this.errorMessagesList = [];
                    this.showMessage('Prepaid Successfully');
                    return true;
                }

            }else {
                const result = await this.do_checkout();
                if (result.data.success === false || result.status !== 200) {
                    if(this.recaptchaWidgetId!= null){
                        grecaptcha.reset(this.recaptchaWidgetId);
                    }
                    if(result.data.hasOwnProperty('errors')){
                        this.errorMessagesList = [];
                        Object.values(result.data.errors).forEach(val => {
                            this.errorMessagesList.push(val[0]);
                        });
                    }else if(result.data.message!=="") {
                        this.errorMessagesList = [result.data.message.includes(":") ? result.data.message.split(":")[1] : result.data.message];
                    }
                } else {
                    var currentUrl = window.location.hostname;
                    let currency = 'USD';
                    if(parseInt(this.$store.state.resources.config.is_international_canadian)){
                        currency = 'CAD';
                    }
                    if(currentUrl == 'silverthorne.pioneersportscolorado.com'){
                        gtag('event', 'conversion',
                         { 'send_to': 'AW-989270699/NaAkCKrTnIEYEKul3NcD', 'value': 1.0, 'currency': currency, 'transaction_id': '' })
                   }
                   else if(currentUrl == 'rentals.pioneersportscolorado.com'){
                        gtag('event', 'conversion',
                        { 'send_to': 'AW-989270699/oqaXCNPvlIEYEKul3NcD', 'value': 1.0, 'currency': currency, 'transaction_id': '' });
                   }

                    if(currentUrl == 'rentals.pinnacleskisports.com' || currentUrl == 'reservations.basinski.com'){
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "rentalCompleted",
                            rental_location: this.config.site_name || '',
                            rental_start_date: this.reservation_start_date || '',
                            rental_end_date: this.reservation_end_date || '',
                            rental_subtotal: this.cost.sub_total || 0,
                            rental_tax: this.is_international_canadian ? this.cost.cost.pst_tax_amount + this.cost.cost.gst_tax_amount : this.cost.tax_amount || 0,
                            rental_total: this.cost.total_price || 0,
                        });
                    }

                    let message = '';
                    if(this.advance_reservation_payment_checkout){
                        message = 'Payment succeed! Thank you!';
                    }
                    if(this.only_save_card_at_advanced || this.skip_checkout){
                        message = 'Reservation saved! Thank you!';
                    }
                    this.errorMessagesList = [];
                    this.showMessage(message);
                    return false;
                }
            }
        },
        getValidationScenario() {
            return 'step_3';
        },

        go_back(){
            this.$store.commit('set_disabled_status', false);
            let n = this.$store.state.currentStepId - 1;
            this.$store.commit('set_step_id', n);
        },
        showMessage(text, success) {

            this.messageDialog.message = text;
            this.messageDialog.success = success === undefined ? true : success;
            this.messageDialog.show = true;
            const self = this;
            setTimeout(function(){
                self.messageDialog.show = false;

                self.redirect();
            },2000);
        },
        reload(){

            window.localStorage.removeItem('last_reservation_id');
            window.location.reload();
        },
        redirect(){
            if(this.$store.state.model.reservation.group_link_id != 0){
                this.reload();
                let url = window.location.protocol+'//'+window.location.host+'/waivers/'+this.$store.state.model.reservation.id+'/edit';
                // window.open(url, '_blank');
                window.location.href = url;
               
            }else if(this.is_redirect_after_reservation_is_complete==1){
                let url = this.redirect_url_after_reservation_is_complete;
                window.location.replace(url);
            }
            else{
                this.reload();
            }

        },

        async main() {

            const that = this;
            let card;
            if (this.is_using_square && (this.only_save_card_at_advanced || this.advance_reservation_payment_checkout) && !that.cost.free_checkout) {
                const payments = Square.payments(that.square_application_id, that.square_location_id);
                card = await payments.card();
                card.attach('#card-container');
            }

            async function eventHandler(event) {
                console.log("Checkout");
                console.log('that.cost.free_checkout', that.cost.free_checkout);
                if ((!that.only_save_card_at_advanced && !that.advance_reservation_payment_checkout) || that.cost.free_checkout || (that.is_prepay && !that.prepay_payment && !that.only_save_card_at_prepay)) {
                    await that.stepSubmit();
                } else {
                    event.preventDefault();
                    try {
                        const result = await card.tokenize();
                        if (result.status === 'OK') {
                            that.$store.commit('set_model_value', {
                                path : 'model.payment.cc',
                                value: '4111111111111111'
                            });
                            that.$store.commit('set_model_value', {
                                path : 'model.payment.cvv',
                                value: '234'
                            });
                            that.$store.commit('set_model_value', {
                                path : 'model.payment._nounce',
                                value: result.token
                            });

                            await that.stepSubmit();
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            };

            const cardButton = document.getElementById('card-button');
            cardButton.addEventListener('click', eventHandler);
        },

        async mainStripe() {
            const that = this;
            let elements;
            let card;
            
            if (that.$store.state.resources.config.gateway =='stripe' && that.skip_checkout==0) {
                if(this.is_prepay) {
                    if(this.prepay_payment || this.only_save_card_at_prepay) {
                        that.stripe = Stripe(that.$store.state.resources.config.stripe_publish);
                        elements = this.stripe.elements();
                        card = elements.create('card', {
                            style: {
                                base: {
                                    fontSize: '16px',
                                },
                            },
                            hidePostalCode: true,
                            disableLink: true,
                        });
                        
                        this.$nextTick(() => {
                            const cardElement = document.getElementById('card-element');
                            if (cardElement) {
                                card.mount('#card-element');
                            } else {
                                console.error("Card element is not present in the DOM");
                            }
                        });

                        card.on('change', function (event) {
                            if (event.complete) {
                                if(that.recaptchaWidgetId != null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                                    if(that.rechapcha_is_checked){
                                        that.$store.commit('set_disabled_status', false);
                                    }else{
                                        that.$store.commit('set_disabled_status', true);
                                    }
                                }else{
                                    that.$store.commit('set_disabled_status', false);
                                }
                            } else {
                                if(that.recaptchaWidgetId != null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                                    if(that.rechapcha_is_checked){
                                        that.$store.commit('set_disabled_status', false);
                                    }else{
                                        that.$store.commit('set_disabled_status', true);
                                    }
                                }else{
                                    that.$store.commit('set_disabled_status', true);
                                }
                            }
                        });
                    }
                } else if(that.only_save_card_at_advanced || that.advance_reservation_payment_checkout) {
                    that.stripe = Stripe(that.$store.state.resources.config.stripe_publish);
                    elements = this.stripe.elements();
                    card = elements.create('card', {
                        style: {
                            base: {
                                fontSize: '16px',
                            },
                        },
                        hidePostalCode: true,
                        disableLink: true,
                    });
                    
                    this.$nextTick(() => {
                        const cardElement = document.getElementById('card-element');
                        if (cardElement) {
                            card.mount('#card-element');
                        } else {
                            console.error("Card element is not present in the DOM");
                        }
                    });

                    card.on('change', function (event) {
                        if (event.complete) {
                            if(that.recaptchaWidgetId != null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                                if(that.rechapcha_is_checked){
                                    that.$store.commit('set_disabled_status', false);
                                }else{
                                    that.$store.commit('set_disabled_status', true);
                                }
                            }else{
                                that.$store.commit('set_disabled_status', false);
                            }
                        } else {
                            if(that.recaptchaWidgetId != null && that.$store.state.resources.config.google_recaptcha=="1" && that.$store.state.resources.config.google_recaptcha_site_key!=''){
                                if(that.rechapcha_is_checked){
                                    that.$store.commit('set_disabled_status', false);
                                }else{
                                    that.$store.commit('set_disabled_status', true);
                                }
                            }else{
                                that.$store.commit('set_disabled_status', true);
                            }
                        }
                    });
                }
            }

            async function eventHandler(event) {
                console.log('that.is_prepay', that.is_prepay);
                console.log('that.prepay_payment', that.prepay_payment);
                console.log('that.only_save_card_at_prepay', that.only_save_card_at_prepay);
                if ((!that.only_save_card_at_advanced && !that.advance_reservation_payment_checkout && !that.is_prepay) || that.cost.free_checkout || that.skip_checkout==1 || (that.is_prepay && !that.prepay_payment && !that.only_save_card_at_prepay)) {
                    await that.stepSubmit();
                } else {
                    event.preventDefault();
                    try {
                        that.$store.commit('set_step_loading', true);
                        const { token, error } = await that.stripe.createToken(card);
                        if (error) {
                            // Handle errors
                            console.error(error);
                            that.$store.commit('set_step_loading', false);
                        } else {
                            that.$store.commit('set_model_value', {
                                path : 'model.payment.cc',
                                value: token.card.last4
                            });

                            that.$store.commit('set_model_value', {
                                path : 'model.payment.stripeToken',
                                value: token.id
                            });

                            await that.stepSubmit();
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            }

            const cardButton = document.getElementById('stripe-card-button');
            cardButton.addEventListener('click', eventHandler);
        }
    },
    computed  : {
        cost() {
            return this.$store.state.model.cost;
        },
        only_save_card_at_advanced() {
            return parseInt(this.$store.state.resources.config.only_save_card_at_advanced);
        },
        advance_reservation_payment_checkout() {
            return parseInt(this.$store.state.resources.config.advance_reservation_payment_checkout);
        },
        notes_in_advance(){
            return parseInt(this.$store.state.resources.config.notes_in_advance);
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        },
        is_using_square() {
            return this.$store.state.resources.config.is_using_squareup;
        },
        show_sms_consent() {
            return parseInt(this.$store.state.resources.config.sms_app);
        },
        is_crested_text() {
            return parseInt(this.$store.state.resources.config.is_crested_text);
        },
        gateway(){
            return this.$store.state.resources.config.gateway;
        },
        square_application_id() {
            return this.$store.state.resources.config.square_application_id
        },
        square_location_id() {
            return this.$store.state.resources.config.square_location_id
        },
        stripe_publish(){
            return this.$store.state.resources.config.stripe_publish
        },
        charge_50_percent(){
            return parseInt(this.$store.state.resources.config.charge_50_percent);
        },
        charge_25_percent(){
            return parseInt(this.$store.state.resources.config.charge_25_percent);
        },
        charge_10_percent(){
            return parseInt(this.$store.state.resources.config.charge_10_percent);
        },
        charge_10_per_person(){
            return parseInt(this.$store.state.resources.config.charge_10_per_person);
        },
        charge_20_per_person(){
            return parseInt(this.$store.state.resources.config.charge_20_per_person);
        },
        charge_30_per_person(){
            return parseInt(this.$store.state.resources.config.charge_30_per_person);
        },
        is_redirect_after_reservation_is_complete() {
            return this.$store.state.resources.config.is_redirect_after_reservation_is_complete
        },
        redirect_url_after_reservation_is_complete() {
            return this.$store.state.resources.config.redirect_url_after_reservation_is_complete
        },
        amount(){
            return ((this.prepay_payment || this.only_save_card_at_prepay) && this.is_prepay) ? parseFloat(this.prepay_total_price).toFixed(2) : this.cost.amount_to_be_paid;
        },
        no_priceing_checkouts() {
            return this.$store.state.resources.config.no_priceing_checkouts;
        },
        config() {
            return this.$store.state.resources.config;
        },
        discounted_dates() {
            const block_dates = this.$store.state.resources.config.block_advance_discount_dates;
            const daysInRange = [];
            let block_dates_in_reservation = [];

            for (let currentDate = moment(this.$store.state.model.reservation.date_pickup); currentDate <= moment(this.$store.state.model.reservation.date_return); currentDate.add(1, 'day')) {
                daysInRange.push(moment(currentDate));
            }
            if(block_dates.length!==0){
                for (const [key, value] of Object.entries(block_dates)) {
                    if(value.start!==null && value.end!==null) {
                        let is_in = false;
                        for(const day of daysInRange){
                            is_in = moment(day, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                            if(is_in){
                                break;
                            }
                        }
                        if (is_in) block_dates_in_reservation.push(value);
                    }
                }
            }
            return block_dates_in_reservation;
        },
        terms_and_conditions_title() {
            return this.$store.state.resources?.policy_and_terms?.terms_and_conditions?.title || 'Terms & Conditions'
        },
        sms_constent_title() {
            return this.$store.state.resources?.policy_and_terms?.sms_consent?.title || 'SMS Consent'
        },
        privacy_policy_title() {
            return this.$store.state.resources?.policy_and_terms?.privacy_policy?.title || 'Privacy Policy'
        },
        cancellation_policy_title() {
            return this.$store.state.resources?.policy_and_terms?.cancellation_policy?.title || 'Cancellation Policy'
        },
        reservation_start_date() {
            return moment(this.reservation.date_pickup).format(this.$store.state.config.dateFormat);
        },
        reservation_end_date() {
            return moment(this.reservation.date_return).format(this.$store.state.config.dateFormat);
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },

        ...mapGetters(['prepay_total_price', 'disabled_status', 'do_not_show_price_on_checkout', 'skip_checkout', 'rechapcha_is_checked'])
    },
    created(){
        if(this.$store.state.resources.config.demo_card && this.$store.state.resources.config.demo_card!==""){
            this.$store.commit('set_model_value', {
                path : 'model.payment.cc',
                value: this.$store.state.resources.config.demo_card
            });
        }
    },
    mounted() {
        this.main();
        const self = this;
        if (window.location.href.includes('prepay')) {
            self.is_prepay = true;
        }
        
        if(this.$store.state.resources.config.gateway =='stripe'){
            this.mainStripe();
        }
        if(this.$store.state.resources.config.gateway =='stripe' || this.$store.state.resources.config.gateway =='squareup'){
            let next_year = parseInt(new Date().getFullYear()) + 1;
            next_year = next_year.toString();
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_year',
                value: next_year
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_month',
                value: '01'
            });
        }
        
        if(((this.$store.state.resources.config.only_save_card_at_advanced==1 || this.$store.state.resources.config.advance_reservation_payment_checkout==1) && !self.is_prepay) || ((this.$store.state.resources.config.prepay_payment=='1' || this.$store.state.resources.config.only_save_card_at_prepay=='1') && self.is_prepay)){
            if(this.recaptchaWidgetId == null && this.$store.state.resources.config.google_recaptcha=="1" && this.$store.state.resources.config.google_recaptcha_site_key!=''){
                if(!this.$store.state.model.cost.free_checkout && self.skip_checkout == 0){
                    if(!this.$store.state.model.reservation.group_link_id){
                        this.invisibleRecaptcha();
                    }
                }
            };
        }
        if(this.$store.state.model.reservation.group_link_id){
            this.$store.commit('set_disabled_status', false);

        }
        this.withValidation({
            getModel() {
                return self.$store.state.model.payment;
            },
            rules : {},
            fields: {}
        })

        if(this.charge_50_percent == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 50% deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 50% deposit to save your reservations";
            }
        }else if(this.charge_25_percent == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 25% deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 25% deposit to save your reservations";
            }
        }else if(this.charge_10_percent == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 10% deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 10% deposit to save your reservations";
            }
        }else if(this.charge_10_per_person == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 10$ deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 10$ deposit to save your reservations";
            }
        }else if(this.charge_20_per_person == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 20$ deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 20$ deposit to save your reservations";
            }
        }else if(this.charge_30_per_person == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 30$ deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 30$ deposit to save your reservations";
            }
        }
    }
}
</script>

<style scoped>
    #card-element{
        padding: 15px;
        border-radius: 4px;
        background: #f8f9fa;
        margin: 15px 0;
    }
</style>
